<template lang="pug">
    b-row
      b-col(md="4")
      b-col(cols="12" md="4")
        h2 Confirmando Usuario
        notifications(group="auth" position="top center")
        icon.loader-in-field(name="refresh" spin)
</template>

<script>
import kexaApi from '@/services/apiService';
import router from '@/router';

export default {
  name: 'confirm_email',
  data() {
    return {
      id: '',
    };
  },
  mounted() {
    if (this.$route.query.uct !== undefined) {
      kexaApi.confirm_email(this.$route.query.uct)
        .then((data) => {
          this.id = data.bodyText;
          this.notifyMessage('success', 'Confirmado', 'El correo fue confirmado exitosamente');
        }).catch(() => {
          this.notifyMessage('error', 'Error', 'El usuario no fue encontrado o ya esta activo');
        });
    } else {
      this.notifyMessage('error', 'Error', 'El token no esta presente');
    }
  },
  methods: {
    notifyMessage(type, title, message) {
      this.$notify({
        group: 'auth',
        type,
        title,
        text: message,
        duration: 5000,
      });
      if (type === 'success') {
        setTimeout(() => router.push({ name: 'password_creation', params: { uct: this.$route.query.uct } }), 5000);
      } else {
        setTimeout(() => router.push({ name: 'login' }), 5000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ConfirmEmail.vue